<template>
  <div v-title :data-title="$route.name">
    <!-- style=" border-style: solid; border-width: 5px; border-color: transparent;" -->
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: white !important;
      "
    >
      <div style="position: relative;">
        <img
           style="width:100%; height:100%; object-fit: cover"
          src="../assets/Battertimg/PC/casetop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 48px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%; /* 继承父级宽度 */
              text-align: center; /* 文本水平居中 */
            "
          >
            Gallery
          </div>
        </div>
      </div>
      <div style="width: 100%; text-align: center">
        <div
          style="
            position: relative;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            margin-top: 50px;
            margin-bottom: 100px;
          "
        >
          <div style="width: 1000px">
            <!-- 新增的动态布局部分 -->
            <div
              v-for="(row, rowIndex) in groupedRows"
              :key="rowIndex"
              class="row"
            >
              <!-- 模式A：左大图 + 右小图垂直排列（偶数行） -->
              <template v-if="rowIndex % 2 === 0">
                <div class="pattern-a">
                  <!-- 左侧大图 -->
                  <div class="cell large" v-if="row[0]" style="width: 100%;">
                    <!-- 图片或视频 -->
                    <div v-if="row[0].type === 'image'" class="media-item" style="width: 100%;">
                      <el-image
                        :src="row[0].FilePath"
                        :preview-src-list="[row[0].FilePath]"
                       fit="cover"
                        class="media-content"
                        style="width: 100%;"
                      />
                    </div>
                    <div v-else-if="row[0].type === 'video'" class="media-item" style="width: 100%;">
                      <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content" style="width: 100%;" >
                        <source :src="row[0].FilePath" type="video/mp4" />
                        您的浏览器不支持视频播放
                      </video>
                    </div>
                  </div>

                  <!-- 右侧小图垂直排列 -->
                  <div class="right-column">
                    <div class="cell small" v-if="row[1]">
                      <div v-if="row[1].type === 'image'" class="media-item">
                        <el-image
                          :src="row[1].FilePath"
                          :preview-src-list="[row[1].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[1].type === 'video'"
                        class="media-item"
                      >
                        <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                          <source :src="row[1].FilePath" type="video/mp4" />
                          您的浏览器不支持视频播放
                        </video>
                      </div>
                    </div>
                    <div class="cell small" v-if="row[2]">
                      <div v-if="row[2].type === 'image'" class="media-item">
                        <el-image
                          :src="row[2].FilePath"
                          :preview-src-list="[row[2].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[2].type === 'video'"
                        class="media-item"
                      >
                        <!-- controls -->
                        <video
                          class="media-content"
                          @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline
                        >
                          <source :src="row[2].FilePath" type="video/mp4" />
                          您的浏览器不支持视频播放
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- 模式B：左小图水平排列 + 右大图（奇数行） -->
              <template v-else>
                <div class="pattern-b">
                  <!-- 左侧小图水平排列 -->
                  <div class="left-column">
                    <div class="cell small" v-if="row[0]">
                      <div v-if="row[0].type === 'image'" class="media-item">
                        <el-image
                          :src="row[0].FilePath"
                          :preview-src-list="[row[0].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[0].type === 'video'"
                        class="media-item"
                      >
                        <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                          <source :src="row[0].FilePath" type="video/mp4" />
                          您的浏览器不支持视频播放
                        </video>
                      </div>
                    </div>
                    <div class="cell small" v-if="row[1]">
                      <div v-if="row[1].type === 'image'" class="media-item">
                        <el-image
                          :src="row[1].FilePath"
                          :preview-src-list="[row[1].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[1].type === 'video'"
                        class="media-item"
                      >
                        <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                          <source :src="row[1].FilePath" type="video/mp4" />
                          您的浏览器不支持视频播放
                        </video>
                      </div>
                    </div>
                  </div>

                  <!-- 右侧大图 -->
                  <div class="cell large" v-if="row[2]">
                    <div v-if="row[2].type === 'image'" class="media-item">
                      <el-image
                        :src="row[2].FilePath"
                        :preview-src-list="[row[2].FilePath]"
                        fit="cover"
                        class="media-content"
                      />
                    </div>
                    <div v-else-if="row[2].type === 'video'" class="media-item">
                      <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                        <source :src="row[2].FilePath" type="video/mp4" />
                        您的浏览器不支持视频播放
                      </video>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    <!-- 底部导航 -->
      <footer class="header-navbar">
        <!-- 第一行：LOGO和导航项 -->
        <div class="top-nav" style="height: 28px !important;">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
          <div style="height: 1px; background-color: #cccccc;margin-top:15px;margin-bottom:18px;"></div>
        <!-- 间距30px后的邮件信息 -->
        <div >
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">
            203 Blackburn Rd Mount Waverley VIC 3149
          </div>
        </div>
      </footer>
    </div>
    <div
      v-else
      style="
        width: 100%;
        border: 1px solid #f8f9fa;
        overflow: hidden;
        position: relative;
        background: white;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%"
          src="../assets/Battertimg/H5/casetop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 28px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%; /* 继承父级宽度 */
              text-align: center; /* 文本水平居中 */
            "
          >
           Gallery
          </div>
        </div>
      </div>
      <!-- 移动端动态布局部分 -->
      <!-- 移动端动态布局部分 -->
      <div
        style="
          width: 100%;
          padding-left: 10px;
          padding-right: 10px;
          margin-top: 30px;
          margin-bottom: 30px;
        "
      >
        <div
          v-for="(row, rowIndex) in groupedRows"
          :key="rowIndex"
          class="mobile-row"
        >
          <!-- 模式A：左大图(60%) + 右小图垂直(各占20%高度) -->
          <template v-if="rowIndex % 2 === 0">
            <div class="mobile-pattern-a">
              <!-- 左侧大图 - 占60%宽度 -->
              <div class="mobile-cell mobile-large" v-if="row[0]">
                <div v-if="row[0].type === 'image'" class="media-item">
                  <el-image
                    :src="row[0].FilePath"
                    :preview-src-list="[row[0].FilePath]"
                    fit="cover"
                    class="media-content"
                  />
                </div>
                <div v-else-if="row[0].type === 'video'" class="media-item">
                  <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                    <source :src="row[0].FilePath" type="video/mp4" />
                    您的浏览器不支持视频播放
                  </video>
                </div>
              </div>

              <!-- 右侧小图垂直排列 - 占40%宽度 -->
              <div class="mobile-right-column">
                <div class="mobile-cell mobile-small" v-if="row[1]">
                  <div v-if="row[1].type === 'image'" class="media-item">
                    <el-image
                      :src="row[1].FilePath"
                      :preview-src-list="[row[1].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[1].type === 'video'" class="media-item">
                    <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                      <source :src="row[1].FilePath" type="video/mp4" />
                      您的浏览器不支持视频播放
                    </video>
                  </div>
                </div>
                <div class="mobile-cell mobile-small" v-if="row[2]">
                  <div v-if="row[2].type === 'image'" class="media-item">
                    <el-image
                      :src="row[2].FilePath"
                      :preview-src-list="[row[2].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[2].type === 'video'" class="media-item">
                    <video @click="toggleFullscreen"  
                          playsinline
                          webkit-playsinline class="media-content">
                      <source :src="row[2].FilePath" type="video/mp4" />
                      您的浏览器不支持视频播放
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 模式B：左小图水平(各占50%) + 右大图(50%) -->
          <template v-else>
            <div class="mobile-pattern-b">
              <!-- 左侧小图水平排列 - 各占50% -->
              <div class="mobile-left-column">
                <div class="mobile-cell mobile-small" v-if="row[0]">
                  <div v-if="row[0].type === 'image'" class="media-item">
                    <el-image
                      :src="row[0].FilePath"
                      :preview-src-list="[row[0].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[0].type === 'video'" class="media-item">
                    <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                      <source :src="row[0].FilePath" type="video/mp4" />
                      您的浏览器不支持视频播放
                    </video>
                  </div>
                </div>
                <div class="mobile-cell mobile-small" v-if="row[1]">
                  <div v-if="row[1].type === 'image'" class="media-item">
                    <el-image
                      :src="row[1].FilePath"
                      :preview-src-list="[row[1].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[1].type === 'video'" class="media-item">
                    <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                      <source :src="row[1].FilePath" type="video/mp4" />
                      您的浏览器不支持视频播放
                    </video>
                  </div>
                </div>
              </div>

              <!-- 右侧大图 - 占50% -->
              <div class="mobile-cell mobile-large" v-if="row[2]">
                <div v-if="row[2].type === 'image'" class="media-item">
                  <el-image
                    :src="row[2].FilePath"
                    :preview-src-list="[row[2].FilePath]"
                    fit="cover"
                    class="media-content"
                  />
                </div>
                <div v-else-if="row[2].type === 'video'" class="media-item">
                  <video @click="toggleFullscreen"
                          playsinline
                          webkit-playsinline class="media-content">
                    <source :src="row[2].FilePath" type="video/mp4" />
                    您的浏览器不支持视频播放
                  </video>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <footer class="mobile-footer-navbar">
        <!-- 垂直排列的容器 -->
        <div class="vertical-container">
          <!-- LOGO区域 -->
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <!-- 导航项区域（手动编写每个项） -->
          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              GALLERY
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <!-- 邮件信息区域 -->
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">
              info@batteryplant.com.au
            </div>
            <div class="email-contentmobile">
              203 Blackburn Rd Mount Waverley VIC 3149
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { get, post } from "../assets/api/api";
import { CasePageList } from "../assets/api/request.js";
export default {
  props: {
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    return {
      activeNav: null, // 跟踪当前激活的导航项
      imageList: [],
      picUrlArr: [
        // { type: "image", url: require("../assets/Battertimg/PC/case.png") },
        // { type: "video", url: require("../assets/Battertimg/PC/video.mp4") },
        // { type: "image", url: require("../assets/Battertimg/PC/case.png") },
        // { type: "video", url: require("../assets/Battertimg/PC/video.mp4") },
        // { type: "image", url: require("../assets/Battertimg/PC/case.png") },
        // { type: "video", url: require("../assets/Battertimg/PC/video.mp4") },
        // { type: "image", url: require("../assets/Battertimg/PC/case.png") },
        // { type: "video", url: require("../assets/Battertimg/PC/video.mp4") },
        // { type: "video", url: require("../assets/Battertimg/PC/video.mp4") },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    this.getCasePageList();
  },
  computed: {
    // 将项目分组为每行3个
    groupedRows() {
      const rows = [];
      for (let i = 0; i < this.picUrlArr.length; i += 3) {
        rows.push(this.picUrlArr.slice(i, i + 3));
      }
      return rows;
    },
  },
  methods: {
    toggleFullscreen(event) {
      const video = event.target;
      // 播放/暂停切换
      if (video.paused) {
        video.play().catch((e) => console.log("播放失败:", e));
      } else {
        video.pause();
      }

      // 全屏请求
      if (document.fullscreenEnabled) {
        if (!document.fullscreenElement) {
          video.requestFullscreen().catch((e) => {
            console.error("全屏失败:", e);
            // 可选：回退到页面全屏
            this.$refs.videoPlayer.classList.add("fullscreen-fallback");
          });
        } else {
          document.exitFullscreen();
        }
      }
    },
    addTypeToMediaItems(data) {
      return data.map((item) => {
        let type = "unknown";

        try {
          if (item.FileFormat) {
            if (item.FileFormat.startsWith("image/")) {
              type = "image";
            } else if (item.FileFormat.startsWith("video/")) {
              type = "video";
            } else {
              // 备用方案：根据文件扩展名判断
              const fileName = item.FileName || "";
              const extension = fileName.split(".").pop().toLowerCase();
              const imageExtensions = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "bmp",
                "webp",
                "svg",
              ];
              const videoExtensions = [
                "mp4",
                "avi",
                "mov",
                "wmv",
                "flv",
                "webm",
                "mkv",
              ];

              if (imageExtensions.includes(extension)) {
                type = "image";
              } else if (videoExtensions.includes(extension)) {
                type = "video";
              }
            }
          }
        } catch (error) {
          console.warn("处理文件类型时出错:", error, item);
        }

        return {
          ...item,
          type: type,
        };
      });
    },
    getCasePageList() {
      get(CasePageList).then((res) => {
        if (res.data.code == 200) {
          if (res.data.case.length !== 0) {
//             let data=[
//     {
//         "FileId": 77,
//         "FileName": "CASE1.png",
//         "FilePath": "http://192.168.8.39:18021/images/CASE1.png",
//         "FileFormat": "image/png"
//     },
//     {
//         "FileId": 78,
//         "FileName": "CASE2.jpg",
//         "FilePath": "http://192.168.8.39:18021/images/CASE2.jpg",
//         "FileFormat": "image/jpeg"
//     },
//     {
//         "FileId": 79,
//         "FileName": "CASE3.png",
//         "FilePath": "http://192.168.8.39:18021/images/CASE3.png",
//         "FileFormat": "image/png"
//     },
//     {
//         "FileId": 80,
//         "FileName": "CASE4.png",
//         "FilePath": "http://192.168.8.39:18021/images/CASE4.png",
//         "FileFormat": "image/png"
//     },
//      {
//         "FileId": 81,
//         "FileName": "CASE4.png",
//         "FilePath": "http://192.168.8.39:18021/images/CASE4.png",
//         "FileFormat": "image/png"
//     },
//       {
//         "FileId": 82,
//         "FileName": "CASE4.png",
//         "FilePath": "http://192.168.8.39:18021/images/CASE4.png",
//         "FileFormat": "image/png"
//     }
// ]
//    const result = this.addTypeToMediaItems(data);
            const result = this.addTypeToMediaItems(res.data.case);
            this.picUrlArr = result;
          }
        }
      });
    },
    loadImages() {
      //   // 实际项目中替换为API调用
      //   const mockData = [
      //     { id: 1, name: "Indoor1", url: "img/imgs/Indoor1.jpg" },
      //     // ...其他测试数据
      //   ];
      //   this.imageList = mockData.map(item => ({
      //     ...item,
      //     url: this.resolveImageUrl(item.url)
      //   }));
      // },
      // resolveImageUrl(relativePath) {
      //   if (relativePath.startsWith('http')) {
      //     return relativePath;
      //   }
      //   // 根据项目配置调整路径解析方式
      //   return new URL(`../assets/${relativePath}`, import.meta.url).href;
    },
    handleImageClick(index) {
      // 确保预览组件已初始化
      this.$nextTick(() => {
        // 获取预览组件实例
        const viewer = document.querySelector(".el-image-viewer");

        if (viewer) {
          // 1. 自动触发放大操作
          this.autoZoom(viewer);

          // 2. 设置初始缩放比例
          setTimeout(() => {
            const img = viewer.querySelector(".el-image-viewer__img");
            if (img) {
              img.style.transform = "scale(1.5)"; // 初始放大1.5倍
            }
          }, 50);
        }
      });
    },
    autoZoom(viewer) {
      // 查找放大按钮并模拟点击
      const zoomInBtn = viewer.querySelector(".el-image-viewer__zoom-in");
      if (zoomInBtn) {
        // 点击两次达到2倍放大效果（可根据需要调整次数）
        zoomInBtn.click();
        setTimeout(() => zoomInBtn.click(), 30);
      }
    },
    // 激活导航项方法
    activateNav(index) {
      this.activeNav = index;
    },
    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");
        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        document.documentElement.scrollTop = 0;
        // this.$router.push("/Case");
        // window.open('https://smartuser.com.au/customerdetails/')
        // this.$router.push("/ProjectGallery")
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");
        this.$router.push("/ContactUs");
      }
    },
    // goinfo() {
    //   // window.sessionStorage.setItem("activeIndex", "/CustomerDetails");
    //   this.$emit("fun", "/CustomerDetails");
    // },
  },
};
</script>
<style>
/* 全局样式 - 放在你的全局CSS文件中 */
/* 增加预览容器尺寸 */
/* .el-image-viewer__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* 设置初始放大比例 */
/* .el-image-viewer__img {
  transform: scale(1.2) !important;
  transition: transform 0.3s ease;
} */

/* 隐藏操作按钮（可选） */
/* .el-image-viewer__btn {
  display: none !important;
} */
</style>
<style>
/* 全屏回退样式 */
.fullscreen-fallback {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: black;
}
</style>
<style scoped>
/* 修复模式B左侧视频播放按钮显示问题 */
.mobile-pattern-b .mobile-left-column .media-content {
  position: relative;
  overflow: visible; /* 确保播放按钮可见 */
}

/* 播放按钮定位优化 */
.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
/* 模式A布局 - 精确比例控制 */
.mobile-pattern-a {
  display: flex;
  gap: 10px;
  width: 100%;
  height: 150px;
  margin-bottom: 20px;
}

/* 左侧大图占60%宽度 */
.mobile-pattern-a .mobile-large {
  flex: 3; /* 60%宽度 (3/5) */
  height: 100%; /* 继承父容器高度 */
}

/* 右侧小图容器占40%宽度 */
.mobile-pattern-a .mobile-right-column {
  flex: 2; /* 40%宽度 (2/5) */
  display: flex;
  flex-direction: column;
  height: 100%; /* 继承父容器高度 */

  /* 视觉间距补偿方案 */
  --spacing: 8px; /* 定义间距变量 */
  gap: calc(var(--spacing) / 1); /* 内部间距 */
  /* 上下内边距补偿 */
  /* padding: calc(var(--spacing) / 2) 0;  */
}

/* 右侧每张小图占左侧大图高度的一半 */
.mobile-pattern-a .mobile-small {
  flex: 1; /* 各占50%高度 */
  min-height: calc(50% - var(--spacing)); /* 精确计算：半高减半间间距 */
}

/* 模式B布局 - 精确比例控制 */
.mobile-pattern-b {
  display: flex;
  gap: 10px;
  width: 100%;
  height: 150px; /* 基础高度 */
  margin-bottom: 20px;
}

/* 左侧小图容器占50%宽度 */
.mobile-pattern-b .mobile-left-column {
  flex: 1; /* 50%宽度 */
  display: flex;
  gap: 10px;
  height: 100%;
}

/* 左侧每张小图占50%宽度 */
.mobile-pattern-b .mobile-small {
  flex: 1; /* 各占50%宽度 */
}

/* 右侧大图占50%宽度 */
.mobile-pattern-b .mobile-large {
  flex: 1; /* 50%宽度 */
}

/* 媒体项通用样式 */
.media-item {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f5f7fa;
}

.media-content {
  width: 100%;
  height: 100%;
  object-fit: over;
  border-radius: 12px;
}
/* 响应式适配 - 基于750设计稿比例缩放 */
/* 超小屏手机 (iPhone 5/SE) 320px */
@media (max-width: 320px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 64px; /* 150 * (320/750) ≈ 64px */
    gap: 7px; /* 17 * (320/750) ≈ 7px */
    margin-bottom: 7px;
  }
  
  .mobile-pattern-a .mobile-right-column,
  .mobile-pattern-b .mobile-left-column {
    gap: 7px;
  }
  
  .mobile-pattern-a .mobile-small {
    height: calc(50% - 3.5px);
  }
}

/* 小屏手机 321px-375px */
@media (min-width: 321px) and (max-width: 375px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 120px;
    gap: 9px; /* 17 * (375/750) = 8.5px ≈ 9px */
    margin-bottom: 9px;
  }
  
  .mobile-pattern-a .mobile-right-column,
  .mobile-pattern-b .mobile-left-column {
    gap: 9px;
  }
  
  .mobile-pattern-a .mobile-small {
    height: calc(50% - 4.5px);
  }
}

/* 中屏手机 (iPhone 6/7/8/X) 376px-414px */
@media (min-width: 376px) and (max-width: 414px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 120px; /* 150 * (414/750) ≈ 83px */
    gap: 9px; /* 17 * (414/750) ≈ 9px */
    margin-bottom: 9px;
  }
  
  .mobile-pattern-a .mobile-right-column,
  .mobile-pattern-b .mobile-left-column {
    gap: 9px;
  }
  
  .mobile-pattern-a .mobile-small {
    height: calc(50% - 4.5px);
  }
}

/* 大屏手机 415px-480px */
@media (min-width: 415px) and (max-width: 480px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 150px; /* 150 * (480/750) = 96px */
    gap: 11px; /* 17 * (480/750) ≈ 11px */
    margin-bottom: 11px;
  }
  
  .mobile-pattern-a .mobile-right-column,
  .mobile-pattern-b .mobile-left-column {
    gap: 11px;
  }
  
  .mobile-pattern-a .mobile-small {
    height: calc(50% - 5.5px);
  }
}

/* 小屏平板 481px-768px */
@media (min-width: 481px) and (max-width: 768px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 150px; /* 保持与大屏手机一致或稍大 */
    gap: 11px;
    margin-bottom: 11px;
  }
  
  .mobile-pattern-a .mobile-right-column,
  .mobile-pattern-b .mobile-left-column {
    gap: 11px;
  }
  
  .mobile-pattern-a .mobile-small {
    height: calc(50% - 5.5px);
  }
}
/* 响应式高度调整 */
@media (min-width: 480px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 180px;
  }
  /* .mobile-pattern-a .mobile-right-column {
    --spacing: 12px; 
  } */
}

@media (min-width: 768px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 220px;
  }
  /* .mobile-pattern-a .mobile-right-column {
    --spacing: 12px;
  } */
}

/* 确保视频控件样式一致 */
video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<style scoped>
.image-row {
  /* 这里可以添加额外的行样式，但通常 <el-row> 会有默认的样式 */
  margin: 0; /* 去除行容器的外边距 */
}

.image-col {
  /* 由于我们使用了 :gutter="0"，这里通常不需要额外的间距样式 */
  padding: 0; /* 去除列容器的内边距（虽然 <el-col> 默认可能没有内边距） */
}

.image-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 0; /* 设置图片之间的间距为0 */
  margin: 0; /* 去除容器自身的外边距 */
  padding: 0; /* 去除容器自身的内边距 */
}

.image-container > el-image {
  flex: 0 0 calc(50% - 0px); /* 每列占据50%的宽度，0px是调整间距的，这里不需要额外间距 */
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

.vc_custom_1627269981297copy {
  /* margin-bottom: -40px !important; */
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
}
/* .vc_custom_1626061515335 {
  margin-bottom: -40px !important;
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
} */
/* .special-link {
  text-decoration: underline;
}
a:link {
  color: blue;
} */
/* 已访问的链接 */
/* a:visited {
  color: purple;
} */

/* 鼠标悬浮在链接上 */
/* a:hover {
  color: red;
} */

/* .mt_20 {
  margin-top: 20px;
}
.mt_10 {
  margin-top: 10px;
}
.text_bold {
  font-weight: 700;
}
.pcss {
  font-family: Poppins;
  font-weight: 300;
  font-style: normal;
  font-size: 15px;
}
.titlecss {
  font-family: Poppins;
  font-style: normal;
} */

/* 图片容器相对定位 */
.banner-text {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  z-index: 10;
}

.text-line-1 {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.text-line-2 {
  font-size: clamp(18px, 2.2vw, 36px);
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .banner-text {
    left: 8%;
  }
}

@media (max-width: 992px) {
  .banner-text {
    left: 6%;
  }
}

@media (max-width: 768px) {
  .banner-text {
    left: 5%;
  }

  .text-line-1 {
    font-size: clamp(20px, 4vw, 32px);
  }

  .text-line-2 {
    font-size: clamp(16px, 3vw, 24px);
  }
}
</style>
<style scoped>
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>
<style scoped>
/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}
.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.logo-section,
.nav-section,
.contact-section {
  text-align: left; /* 确保左对齐 */
}
.logo-container {
  margin-bottom: 10px;
}
.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
/* 响应式调整 */
@media (max-width: 480px) {
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
</style>

<style scoped>

/* 基础容器样式 */
.row {
  margin-bottom: 18px;
  width: 100%;
  height: 280px; /* 统一行高 */
}
/* 模式A样式：左大图 + 右小图垂直排列 */
.pattern-a {
  display: flex;
  gap: 18px;
  width: 100%;
  height: 100%; /* 继承行高 */
}

.pattern-a .large {
  flex: 2; /* 占2/3宽度 */
  height: 100%; /* 大图占满整个行高 */
}

.pattern-a .right-column {
  flex: 1; /* 占1/3宽度 */
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%; /* 右列占满整个行高 */
}

.pattern-a .small {
  flex: 1;
  height: calc(50% - 5px); /* 每个小图占右列高度的一半，减去间隙的一半 */
}

/* 模式B样式：左小图水平排列 + 右大图 */
.pattern-b {
  display: flex;
  gap: 18px;
  width: 100%;
  height: 100%; /* 继承行高 */
}

.pattern-b .left-column {
  flex: 1; /* 占50%宽度 */
  display: flex;
  flex-direction: row; /* 水平排列 */
  gap: 18px;
  height: 100%; /* 左列占满整个行高 */
}

.pattern-b .small {
  flex: 1; /* 每个小图占左列宽度的一半 */
  height: 100%; /* 小图占满整个左列高度 */
}

.pattern-b .large {
  flex: 1; /* 占50%宽度 */
  height: 100%; /* 大图占满整个行高 */
}

/* 媒体项样式 */
.media-item {
  width: 100%;
  height: 100%;
  border-radius: 10px; /* 添加圆角 */
  overflow: hidden; /* 确保内容不会超出圆角边界 */
}

.media-content {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例并填满容器 */
  border-radius: 12px; /* 确保图片/视频本身也有圆角 */
}
/* ::v-deep .pattern-a .large .el-image .el-image__inner {
  width: auto !important; 
  height: 100% !important;
  max-width: 100%;
  object-fit: contain !important;
  object-position: left center !important;
}
::v-deep .pattern-a .large .el-image {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: flex-start; 
  align-items: center; 
}
::v-deep .pattern-a .large .el-image .el-image__inner {
  position: relative; 
  width: auto;
  height: 100%;
}  */
/* 响应式调整 */
@media (max-width: 1200px) {
  .row {
    height: 300px; /* 小屏幕时调整行高 */
  }
}

@media (max-width: 850px) {
  .row {
    height: auto; /* 移动端恢复自动高度 */
    flex-direction: column;
  }

  .pattern-a,
  .pattern-b {
    flex-direction: column;
    height: auto;
  }

  .pattern-a .large,
  .pattern-b .large,
  .pattern-a .small,
  .pattern-b .small {
    height: 200px; /* 移动端统一高度 */
  }
}
</style>